export const downloadFile = (url: string, fileName: string) => {
   const link = document.createElement('a');
   link.target = '_blank';
   link.download = fileName;
   link.href = url;
   link.click();
};
